/**
 * Entry point for the Landing Page React app
 * This is served at the root URL (/)
 */

import "./index.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import posthog from "posthog-js";
import { PostHogProvider } from "@posthog/react";
import { LandingPage } from "./components/LandingPage";

posthog.init(process.env.PUBLIC_POSTHOG_KEY as string, {
  api_host: "https://us.i.posthog.com",
  defaults: "2025-11-30",
});

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <PostHogProvider client={posthog}>
      <LandingPage />
    </PostHogProvider>
  </StrictMode>
);

if (import.meta.hot) {
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  createRoot(elem).render(app);
}

